<template>
    <!-- Card -->
    <div class="card" style="max-width: 20rem;">
        <div class="card-body">
            <span class="card-subtitle">{{ machine.serial }}</span>
            <h3 class="card-title">Machine Details</h3>
            <dl class="card-body list-unstyled list-py-2">
                <dt>PIN</dt>
                <dd>{{ machine.pin }}</dd>
                <dt>Created</dt>
                <dd>{{ moment(machine.created).format("YYYY/MM/D")}}</dd>
                <dt>Provider</dt>
                <dd>{{ machine.dme ? machine.dme.name : ''}}</dd>
            </dl>
        </div>
    </div>
    <!-- End Card -->


    <DevicesDisplay :uri="'/api/machines/' + machine.id + '/history'" context="machine" />
</template>

<script setup>
import DevicesDisplay from "../devices/DeviceDisplay.vue";
import moment from "moment";
import {date} from "@/utilities/date";

const props = defineProps({
    machine: {
        type: Object,
        default: 1
    },
});

function start_date(history) {
    return date(history.start_date);
}
function end_date(history) {
    if (history.end_date) {
        return date(history.end_date);
    }
    return 'present';
}
</script>
